module.exports = __webpack_public_path__ + "img/empty_oxygen.0173eb4.png";